import { useEffect } from 'react'
import { useAuthStore } from '../../../store/authStore'

/**
 * App boot: exchange httpOnly refresh cookie for an in-memory access token.
 * Must run once before ProtectedRoute trusts isAuthenticated.
 */
export function useAuthBootstrap() {
  const bootstrapSession = useAuthStore((s) => s.bootstrapSession)
  const isSessionReady = useAuthStore((s) => s.isSessionReady)

  useEffect(() => {
    void bootstrapSession()
  }, [bootstrapSession])

  return isSessionReady
}
